// extracted by mini-css-extract-plugin
module.exports = {"info":"InfoText_info__Q3BFN"};